import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HttpNoInterceptorsService {
  private readonly httpClient: HttpClient;

  constructor(private readonly httpBackend: HttpBackend) {
    this.httpClient = new HttpClient(this.httpBackend);
  }

  getHttpClient(): HttpClient {
    return this.httpClient;
  }
}
